<template>
  <div>
    <!-- <div>sss</div> -->
    <div class="flex">
      <div class="flex-1">
        <div class="mb10 flex flex-end">
          <el-cascader
          v-model="searchCondition.categoryId"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="categoryFunc"
          clearable
          placeholder="请选择类目"
        ></el-cascader>
        <el-input
          clearable
          style="width: 300px"
          v-model.trim="searchCondition.queryGoodsValue"
          size="small"
          :placeholder="placeholder"
          class="ipt mr10"
        >
          <el-select
            slot="prepend"
            size="small"
            style="width: 100px"
            @change="selectQueryType"
            v-model="searchCondition.queryGoodsType"
          >
            <el-option label="商品名" value="spuName"></el-option>
            <el-option label="货号" value="goodsSn"></el-option>
            <el-option label="条码" value="specBarcode"></el-option>
            <el-option label="品牌名" value="brandName"></el-option>
          </el-select>
        </el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        </div>
        
        <div class="border">
          <div class="text-center border-bottom p10">待选商品</div>
          <el-table
            stripe
            ref="brandTable"
            @selection-change="getLeftChecked"
            :data="leftData"
            style="width: 100%"
            id="table"
            @row-click="tableSelect"
            size="small"
            height="500"
          >
            <!-- <el-table-column header-align="center" label="待选商品"> -->
            <el-table-column type="selection"></el-table-column>
            <el-table-column
              type="index"
              label="序号"
              :index="(index) => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsSn"
              label="商品货号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="商品名称"
              show-overflow-tooltip
              width="200"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="categoryName"
              label="分类"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="repurchaseCycleNum"
              label="复购周期"
            ></el-table-column>
            <!-- </el-table-column> -->
          </el-table>
<!--          <div class="hm-pagination">-->
<!--            <el-pagination-->
<!--              background-->
<!--              :total="total"-->
<!--              @current-change="paging"-->
<!--              @size-change="handleSizeChange"-->
<!--              layout="total,  prev, pager, next, jumper"-->
<!--              :current-page="currentPage"-->
<!--            ></el-pagination>-->
<!--          </div>-->
        </div>
      </div>
      <div class="flex flex-column control text-center flex-center">
        <div class="mb20">操作</div>
        <el-button
          size="small"
          class="hmicon icon-youshuangjiantou1"
          @click="allToRight"
          :disabled="leftData.length <= 0"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-youjiantou"
          @click="toRight"
          :disabled="leftData.length <= 0 || leftChecked.length <= 0"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuoshuangjiantou1"
          @click="allToLeft"
          :disabled="rightData.length <= 0"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuojiantou"
          @click="toLeft"
          :disabled="rightData.length <= 0 || rightChecked.length <= 0"
        ></el-button>
      </div>
      <div class="flex-1 border">
        <div class="text-center border-bottom p10">已选商品</div>
        <el-table
          stripe
          ref="brandTable1"
          @selection-change="getRightChecked"
          :data="rightData"
          style="width: 100%"
          id="table"
          @row-click="tableSelect1"
          size="small"
          height="550"
        >
          <!-- <el-table-column header-align="center" label="已选商品"> -->
          <el-table-column type="selection"></el-table-column>
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsSn"
            label="商品货号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="商品名称"
            show-overflow-tooltip
            width="200"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryName"
            label="分类"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="repurchaseCycleNum"
            label="复购周期"
          ></el-table-column>
          <!-- </el-table-column> -->
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    time: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      default: ""
    }
  },
  components: {},
  data() {
    return {
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      pageSize: 9999,
      currentPage: 1,
      total: 0,
      leftData: [],
      leftChecked: [],
      rightData: [],
      rightChecked: [],
      searchCondition: {
        queryGoodsType: "spuName"
      },
      placeholder: "请输入商品名"
    };
  },
  computed: {},
  watch: {
    time(val) {
      if (this.isArray(val)) {
        this.rightData = [];
        this.queryList();
      }
    }
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    tableSelect(row, column, event) {
      this.$refs.brandTable.toggleRowSelection(row);
    },
    tableSelect1(row, column, event) {
      this.$refs.brandTable1.toggleRowSelection(row);
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    selectQueryType(queryType) {
      if (queryType === "spuName") {
        this.placeholder = "请输入商品名";
      } else if (queryType === "goodsSn") {
        this.placeholder = "请输入货号";
      } else if (queryType === "specBarcode") {
        this.placeholder = "请输入条码";
      } else if (queryType === "brandName") {
        this.placeholder = "请输入品牌名";
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        queryType: "repurchasePlan",
        queryStartTime: this.time[0],
        queryEndTime: this.time[1],
        planId: this.id
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.categoryId = this.isArray(searchCondition.categoryId)
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : searchCondition.categoryId;

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryStoreRepurchaseSkuInfoList",
        params
      );
      const { records, total } = result;
      this.leftData = records;
      this.rightData.forEach(v => {
        this.leftData.forEach((item, index) => {
          if (v.skuId === item.skuId) {
            this.leftData.splice(index, 1);
          }
        });
      });

      this.total = total;
    },
    duplicate() {
      this.rightData.forEach(v => {
        this.leftData.forEach((item, index) => {
          if (v.skuId === item.skuId) {
            this.leftData.splice(index, 1);
          }
        });
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    getLeftChecked(leftChecked) {
      this.leftChecked = leftChecked;
    },

    getRightChecked(rightChecked) {
      this.rightChecked = rightChecked;
    },
    checkCommon(checkedData, data) {
      let result = false;
      checkedData.forEach(v => {
        data.forEach(item => {
          if (String(v.skuId) === String(item.skuId)) {
            this.$message({
              message: "请不要移动重复项",
              type: "warning"
            });
            result = true;
          }
        });
      });
      return result;
    },
    allToRight() {
      // 移动所有到右边
      const result = this.checkCommon(this.leftData, this.rightData);
      if (!result) {
        if (this.leftData.length) {
          this.rightData.push.apply(this.rightData, this.leftData);
          this.leftData = [];
          this.leftChecked = [];
          this.leftCheckAll = false;
          this.rightCheckAll = true;
        }

        // if (this.showUseable) {
        //   this.leftData.forEach(v => {
        //     v.useable = this.useable;
        //   });
        // }
        // if (this.queryIsUsed) {
        //   this.$store
        //     .dispatch("queryGoodsIsUsed", {
        //       leftData: this.leftData
        //     })
        //     .then(res => {
        //       if (this.leftData.length > 0) {
        //         this.rightData = this.rightData.concat(res.result);
        //         this.rightData.forEach(v => {
        //           v.activityName = v.existActivity
        //             ? v.existActivity.map(item => item.promotionName)
        //             : [];
        //           v.activityStr = v.activityName.join(",");
        //           if (this.isMustDelivery) {
        //             v.isMustDelivery = this.isMustDelivery;
        //           }
        //         });
        //         this.leftData = [];
        //         this.leftChecked = [];
        //       }
        //       this.handleRightCheckAllChange(true);
        //       this.leftCheckAll = false;
        //       this.rightCheckAll = true;
        //     });
        // } else {
        //   if (this.leftData.length > 0) {
        //     this.rightData = this.rightData.concat(this.leftData);
        //     this.rightData.forEach(v => {
        //       if (this.isMustDelivery) {
        //         v.isMustDelivery = this.isMustDelivery;
        //       }
        //     });
        //     this.leftData = [];
        //     this.leftChecked = [];
        //   }
        //   this.handleRightCheckAllChange(true);
        //   this.leftCheckAll = false;
        //   this.rightCheckAll = true;
        // }
      }
    },
    toRight() {
      // 移动选中到右边
      const result = this.checkCommon(this.leftChecked, this.rightData);
      if (!result) {
        this.rightData.push.apply(this.rightData, this.leftChecked);
        this.leftChecked.forEach(v => {
          this.leftData.forEach((item, index) => {
            if (v.skuId === item.skuId) {
              this.leftData.splice(index, 1);
            }
          });
        });
        this.leftChecked = [];
        this.leftIsIndeterminate = false;
        this.leftCheckAll = false;
        this.rightCheckAll = true;
        // if (this.showUseable) {
        //   this.leftData.forEach(v => {
        //     v.useable = this.useable;
        //   });
        // }
        // if (this.queryIsUsed) {
        //   this.$store
        //     .dispatch("queryGoodsIsUsed", {
        //       leftData: this.leftChecked
        //     })
        //     .then(res => {
        //       this.rightData = this.rightData.concat(res.result);
        //       this.rightData.forEach(v => {
        //         v.activityName = v.existActivity
        //           ? v.existActivity.map(item => item.promotionName)
        //           : [];
        //         v.activityStr = v.activityName.join(",");
        //         if (this.isMustDelivery) {
        //           v.isMustDelivery = this.isMustDelivery;
        //         }
        //       });
        //       this.leftChecked = [];
        //       this.leftIsIndeterminate = false;
        //       this.leftCheckAll = false;
        //       this.handleRightCheckAllChange(true);
        //       this.rightCheckAll = true;
        //     });
        // } else {
        //   this.rightData = this.rightData.concat(this.leftChecked);
        //   this.rightData.forEach(v => {
        //     if (this.isMustDelivery) {
        //       v.isMustDelivery = this.isMustDelivery;
        //     }
        //   });
        // }
        // if (this.leftChecked.length === this.leftData.length) {
        //   this.leftData = [];
        // } else if (this.leftChecked.length === 1) {
        //   this.leftData.forEach((v, i) => {
        //     if (v.id === this.leftChecked[0].id) {
        //       this.leftData.splice(i, 1);
        //     }
        //   });
        // } else {
        //   this.leftChecked.forEach(v => {
        //     this.leftData.forEach((item, index) => {
        //       if (v.id === item.id) {
        //         this.leftData.splice(index, 1);
        //       }
        //     });
        //   });
        // }
        // this.leftChecked = [];
        // this.leftIsIndeterminate = false;
        // this.leftCheckAll = false;
        // this.handleRightCheckAllChange(true);
        // this.rightCheckAll = true;
      }
    },
    allToLeft() {
      // 移动所有到左边
      const result = this.checkCommon(this.rightData, this.leftData);
      if (!result) {
        this.rightCheckAll = false;
        this.rightIsIndeterminate = false;
        if (this.rightData.length) {
          this.leftData.push.apply(this.leftData, this.rightData);
          //   this.leftData = this.leftData.concat(this.rightData);
          this.rightData = [];
          this.rightChecked = [];
        }
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    toLeft() {
      // 移动选中到左边
      const result = this.checkCommon(this.rightChecked, this.leftData);
      if (!result) {
        this.leftData.push.apply(this.leftData, this.rightChecked);
        this.rightChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (v.skuId === item.skuId) {
              this.rightData.splice(index, 1);
            }
          });
        });
        this.rightChecked = [];
        this.rightIsIndeterminate = false;

        // this.leftData = this.leftData.concat(this.rightChecked);
        // if (this.rightChecked.length === this.rightData.length) {
        //   this.rightData = [];
        //   this.rightChecked = [];
        //   this.rightCheckAll = false;
        // } else if (this.rightChecked.length === 1) {
        //   this.rightData.forEach((v, i) => {
        //     if (v.id === this.rightChecked[0].id) {
        //       this.rightData.splice(i, 1);
        //     }
        //   });
        //   this.rightChecked = [];
        // } else {
        //   this.rightChecked.forEach(v => {
        //     this.rightData.forEach((item, index) => {
        //       if (v.id === item.id) {
        //         this.rightData.splice(index, 1);
        //       }
        //     });
        //   });
        // }
        // this.rightChecked = [];
        // this.rightIsIndeterminate = false;
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.control {
  width: 130px;
  margin: 0 2rem;
  .el-button {
    margin: 0.5rem;
  }
}
.border {
  border: 1px solid #ddd;
  border-radius: 4px 4px 0px 0px;
}
.border-bottom {
  border-bottom: 1px solid #ddd;
  color: #222;
}
</style>
